export default function ToolBarIcons() {
  return (
    <span style={{ display: 'none' }}>
      <svg
        style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <symbol id="icon-loader" viewBox="0 0 100 100">
            <g transform="rotate(0 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.9166666666666666s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(30 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.8333333333333334s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(60 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate attributeName="opacity" values="1;0" dur="1s" begin="-0.75s" repeatCount="indefinite" />
              </rect>
            </g>
            <g transform="rotate(90 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.6666666666666666s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(120 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.5833333333333334s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(150 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate attributeName="opacity" values="1;0" dur="1s" begin="-0.5s" repeatCount="indefinite" />
              </rect>
            </g>
            <g transform="rotate(180 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.4166666666666667s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(210 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.3333333333333333s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(240 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate attributeName="opacity" values="1;0" dur="1s" begin="-0.25s" repeatCount="indefinite" />
              </rect>
            </g>
            <g transform="rotate(270 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.16666666666666666s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(300 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate
                  attributeName="opacity"
                  values="1;0"
                  dur="1s"
                  begin="-0.08333333333333333s"
                  repeatCount="indefinite"
                />
              </rect>
            </g>
            <g transform="rotate(330 50 50)">
              <rect x="47" y="24" rx="9.4" ry="4.8" width="6" height="12" fill="#1d0e0b">
                <animate attributeName="opacity" values="1;0" dur="1s" begin="0s" repeatCount="indefinite" />
              </rect>
            </g>
          </symbol>
          <symbol id="icon-chevron-down" viewBox="0 0 20 20">
            {/*<title>chevron-down</title>*/}
            <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" />
          </symbol>
          <symbol id="icon-chevron-right" viewBox="0 0 24 24">
            {/*<title>chevron-right</title>*/}
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </symbol>
          <symbol id="icon-cross" viewBox="0 0 24 24">
            {/*<title>cross</title>*/}
            <path d="M12,0C5.4,0,0,5.4,0,12s5.4,12,12,12s12-5.4,12-12S18.6,0,12,0z M16.7,15.3c0.4,0.4,0.4,1,0,1.4 C16.5,16.9,16.3,17,16,17s-0.5-0.1-0.7-0.3L12,13.4l-3.3,3.3C8.5,16.9,8.3,17,8,17s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l3.3-3.3 L7.3,8.7c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L13.4,12L16.7,15.3z" />
          </symbol>
          <symbol id="icon-dots-three-horizontal" viewBox="0 0 20 20">
            {/*<title>dots-three-horizontal</title>*/}
            <path d="M10.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2zM3.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.986 2.199-2.2s-0.984-2.2-2.199-2.2zM17.001 7.8c-1.215 0-2.201 0.985-2.201 2.2s0.986 2.2 2.201 2.2c1.215 0 2.199-0.985 2.199-2.2s-0.984-2.2-2.199-2.2z" />
          </symbol>
          <symbol id="icon-clock" viewBox="0 0 512 512">
            {/*<title>clock</title>*/}
            <path d="M329.372 374.628l-105.372-105.373v-141.255h64v114.745l86.628 86.627zM256 0c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256zM256 448c-106.039 0-192-85.961-192-192s85.961-192 192-192c106.039 0 192 85.961 192 192s-85.961 192-192 192z" />
          </symbol>
          <symbol id="icon-v-ellipsis" viewBox="0 0 36 36">
            <path d="M18 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0 3c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
          </symbol>
          <symbol id="icon-ellipsis" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="2" />
            <circle cx="3" cy="12" r="2" />
            <circle cx="21" cy="12" r="2" />
          </symbol>
          <symbol id="icon-toknow" viewBox="0 0 24 24">
            <polyline points="1.8,-0.2 20.2,-0.2 16.1,5.8 20.2,11.9 1.8,11.9" />
            <path d="M1.8-0.2v22.3" />
          </symbol>
          <symbol id="icon-todo" viewBox="0 0 24 24">
            <path d="M19.5,8.6c0.2,0.8,0.3,1.6,0.3,2.5c0,5.2-4.3,9.5-9.5,9.5s-9.5-4.3-9.5-9.5s4.3-9.5,9.5-9.5c1.9,0,3.6,0.5,5,1.4" />
            <polyline points="6.6,9.4 10.6,13.2 21.4,2.7" />
          </symbol>
          <symbol version="1.1" id="icon-wg" x="0px" y="0px" viewBox="0 0 570 570">
            <g>
              <path
                id="piece_1_2_"
                className="st3"
                d="M208,257.1l-56,84.6h-47.3c-3.4,0-6.5,1.8-8.2,4.7l-29.3,50.8c-1.7,2.9-1.7,6.5,0,9.4
              l29.3,50.8c1.7,2.9,4.8,4.7,8.2,4.7h58.7c3.4,0,6.5-1.8,8.2-4.7l29.3-50.8c1.7-2.9,1.7-6.5,0-9.4l-20.1-34.7l57.4-87.1l-64.3-110.1
              c-1.6-2.7-1.6-6.1,0-8.9L227.5,64c1.6-2.7,4.5-4.4,7.7-4.4h106.7c3.2,0,6.1,1.7,7.7,4.4l53.4,92.4c1.6,2.7,1.6,6.1,0,8.9
              l-18.7,32.4l10.2,15.3l22.8-39.4c4.5-7.8,4.5-17.6,0-25.4l-53.4-92.4c-4.5-7.8-13-12.7-22-12.7H235.2c-9,0-17.5,4.9-22,12.7
              l-53.4,92.4c-4.5,7.8-4.5,17.6,0,25.4L208,257.1z"
              />
              <path
                id="piece_3_2_"
                className="st3"
                d="M509.3,396.8l-32-55.5c-1.8-3.2-5.2-5.1-8.9-5.1h-64c-3.7,0-7.1,2-8.9,5.1l-22.7,39.3H263.4
              l-68.2,118.1c-1.6,2.7-4.5,4.4-7.7,4.4H80.8c-3.2,0-6.1-1.7-7.7-4.4l-53.4-92.4c-1.6-2.7-1.6-6.1,0-8.9L73.1,305
              c1.6-2.7,4.5-4.4,7.7-4.4h44.8l10.9-16.5H80.8c-9,0-17.5,4.9-22,12.7L5.4,389.2c-4.5,7.8-4.5,17.6,0,25.4L58.8,507
              c4.5,7.8,13,12.7,22,12.7h106.7c9,0,17.5-4.9,22-12.7l52.4-90.8h106.8l26.7,46.3c1.8,3.2,5.2,5.1,8.9,5.1h64c3.7,0,7.1-2,8.9-5.1
              l32-55.5C511.1,403.9,511.1,400,509.3,396.8z"
              />
              <path
                id="piece_2_2_"
                className="st3"
                d="M565.1,389.2l-53.4-92.4c-4.5-7.8-13-12.7-22-12.7H388.6l-50.9-76.9l23.8-41.2
              c1.8-3.2,1.8-7.1,0-10.3l-32-55.5c-1.8-3.2-5.2-5.1-8.9-5.1h-64c-3.7,0-7.1,2-8.9,5.1l-32,55.5c-1.8,3.2-1.8,7.1,0,10.3l32,55.5
              c1.8,3.2,5.2,5.1,8.9,5.1h51.3l49.1,74.1l132.8-0.1c3.2,0,6.1,1.7,7.7,4.4l53.4,92.4c1.6,2.7,1.6,6.1,0,8.9l-53.4,92.4
              c-1.6,2.7-4.5,4.4-7.7,4.4H383.1c-3.2,0-6.1-1.7-7.7-4.4L354.6,463h-19.1l25.4,44.1c4.5,7.8,13,12.7,22,12.7h106.7
              c9,0,17.5-4.9,22-12.7l53.4-92.4C569.6,406.8,569.6,397.1,565.1,389.2z"
              />
            </g>
          </symbol>
          <symbol id="icon-feedback" viewBox="0 0 24 24">
            <path d="M8.5,13.8l2.9,4.3c0.5,0.8,0.3,1.8-0.5,2.4l0,0c-0.8,0.5-1.9,0.3-2.4-0.5l-3.9-6.2" />
            <path d="M3.7,12.8c-1.6,0-2.9-1.3-2.9-2.9S2.1,7,3.7,7" />
            <polyline points="11.4,6.1 20.1,1.2 20.1,18.6 11.4,13.8" />
            <rect x="3.7" y="6.1" className="st2" width="7.7" height="7.7" />
          </symbol>
          <symbol id="icon-ask" viewBox="0 0 24 24">
            <path d="M13.5,18.6h-4l-0.3-4.7l-1.7-0.7V8.9c0-1.1,0.9-2,2-2h4c1.1,0,2,0.9,2,2v4.4l-1.7,0.7L13.5,18.6z" />
            <circle cx="11.5" cy="2.9" r="2.1" />
            <path d="M15.8,16.3c3.2,0.4,5.4,1.3,5.4,2.2c0,1.4-4.5,2.5-10.1,2.5S0.9,19.9,0.9,18.5c0-1,2.2-1.8,5.4-2.2" />
          </symbol>
          <symbol id="icon-bar-arrow" viewBox="0 0 5.5 24">
            <polygon
              transform="translate(5.500000, 11.000000) rotate(-90.000000) translate(-5.500000, -11.000000) "
              points="5.5 5.5 16.5 16.5 -5.5 16.5"
            />
          </symbol>
          <symbol id="icon-refresh" viewBox="0 0 48 48">
            <path d="M24 10V2L14 12l10 10v-8c6.63 0 12 5.37 12 12s-5.37 12-12 12-12-5.37-12-12H8c0 8.84 7.16 16 16 16s16-7.16 16-16-7.16-16-16-16z" />
          </symbol>
          <symbol id="inline-icon-flag" viewBox="0 0 16 16">
            <path d="M13,6l2-5H3c0-0.6-0.4-1-1-1S1,0.4,1,1v14c0,0.6,0.4,1,1,1s1-0.4,1-1v-4h12L13,6z" />
          </symbol>
          <symbol id="icon-trashcan" viewBox="0 0 16 16">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="M2.5,6.5v7 c0,1.105,0.895,2,2,2h8c1.105,0,2-0.895,2-2v-7"
            />{' '}
            <line
              data-color="color-2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              x1="1.5"
              y1="3.5"
              x2="15.5"
              y2="3.5"
            />{' '}
            <polyline
              data-color="color-2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              points=" 6.5,3.5 6.5,0.5 10.5,0.5 10.5,3.5 "
            />{' '}
            <line
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              x1="8.5"
              y1="7.5"
              x2="8.5"
              y2="12.5"
            />{' '}
            <line
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              x1="11.5"
              y1="7.5"
              x2="11.5"
              y2="12.5"
            />{' '}
            <line
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              x1="5.5"
              y1="7.5"
              x2="5.5"
              y2="12.5"
            />
          </symbol>
          <symbol id="feedback-star" viewBox="0 0 24 24">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </symbol>
          <symbol id="feedback-success" viewBox="0 0 24 24">
            <path d="M20.4,8.4c-0.5,0.1-0.8,0.7-0.7,1.2c0.2,0.8,0.3,1.6,0.3,2.4c0,5-4,9-9,9s-9-4-9-9s4-9,9-9 c1.7,0,3.3,0.5,4.7,1.3c0.5,0.3,1.1,0.1,1.4-0.3c0.3-0.5,0.1-1.1-0.3-1.4C15,1.6,13,1,11,1C4.9,1,0,5.9,0,12s4.9,11,11,11 s11-4.9,11-11c0-1-0.1-2-0.4-2.9C21.5,8.6,20.9,8.3,20.4,8.4z" />
            <path d="M22.7,2.3c-0.4-0.4-1-0.4-1.4,0L11,12.6L7.7,9.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4,4 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l11-11C23.1,3.3,23.1,2.7,22.7,2.3z" />
          </symbol>
          <symbol id="icon-person" viewBox="0 0 64 64">
            <path d="M32,1C14.906,1,1,14.907,1,32s13.906,31,31,31s31-13.907,31-31S49.094,1,32,1z M20,28 c0-6.617,5.383-12,12-12s12,5.383,12,12v3c0,6.617-5.383,12-12,12s-12-5.383-12-12V28z M32,61c-6.701,0-12.873-2.291-17.789-6.122 C17.082,49.99,22.26,47,28,47h8c5.733,0,10.911,2.99,13.788,7.879C44.872,58.71,38.7,61,32,61z" />
          </symbol>
          <symbol id="icon-alert" viewBox="0 0 64 64">
            <path d="M62.874,59.514l-30-54c-0.353-0.635-1.396-0.635-1.748,0l-30,54c-0.172,0.31-0.167,0.688,0.012,0.993 C1.318,60.812,1.646,61,2,61h60c0.354,0,0.682-0.188,0.862-0.493C63.042,60.202,63.046,59.824,62.874,59.514z M34.857,24 l-1.429,20.714h-2.857L29.143,24H34.857z M32,55c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S33.657,55,32,55z" />
          </symbol>
          <symbol id="icon-warning" viewBox="0 0 64 64">
            <path d="M61,1H3C1.895,1,1,1.895,1,3v58c0,1.105,0.895,2,2,2h58c1.105,0,2-0.895,2-2V3C63,1.895,62.105,1,61,1z M34.621,13l-1.31,26.862H30.69L29.379,13H34.621z M32,51c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S33.657,51,32,51z" />
          </symbol>
          <symbol id="icon-informational" viewBox="0 0 64 64">
            <path d="M32,1C14.907,1,1,14.907,1,32s13.907,31,31,31s31-13.907,31-31S49.093,1,32,1z M34.621,13l-1.31,26.862 H30.69L29.379,13H34.621z M32,51c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S33.657,51,32,51z" />
          </symbol>
          <symbol id="icon-like" viewBox="0 0 16 16">
            <path d="M14,6H8V2c0-1.2-0.8-2-2-2L3,7H1C0.4,7,0,7.4,0,8v7c0,0.6,0.4,1,1,1h11c1.4,0,2.7-1,2.9-2.4l1-5.2 C16.2,7.2,15.3,6,14,6z" />
          </symbol>
          <symbol id="icon-comment" viewBox="0 0 16 16">
            <path d="M8,0C3.6,0,0,3.1,0,7c0,3.9,3.6,7,8,7c0.4,0,0.8,0,1.1-0.1L14,16v-4.4c1.2-1.2,2-2.8,2-4.6 C16,3.1,12.4,0,8,0z" />
          </symbol>
          <symbol id="icon-bookmark" viewBox="0 0 16 16">
            <path d="M4,0C2.9,0,2,0.9,2,2v14l6-3l6,3V2c0-1.1-0.9-2-2-2H4z" />
          </symbol>
          <symbol id="icon-delete" viewBox="0 0 24 24">
            <path d="M21,8H3v14c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2V8z" />{' '}
            <path
              data-color="color-2"
              fill="#cfcfcf"
              d="M23,4h-7c0-2.206-1.794-4-4-4S8,1.794,8,4H1C0.447,4,0,4.448,0,5s0.447,1,1,1h22 c0.553,0,1-0.448,1-1S23.553,4,23,4z M12,2c1.103,0,2,0.897,2,2h-4C10,2.897,10.897,2,12,2z"
            />
          </symbol>
          <symbol id="icon-share" viewBox="0 0 24 24">
            <path d="M13,15v6.4L23.4,11L13,0.6V7C8.4,7.2,0,9.1,0,20v3.7l1.9-3.2C4.3,16.4,6.7,15.1,13,15z" />
          </symbol>
          <symbol id="icon-calendar" viewBox="0 0 16 16">
            <path d="M15,2h-2V0h-3v2H6V0H3v2H1C0.448,2,0,2.448,0,3v12c0,0.552,0.448,1,1,1h14c0.552,0,1-0.448,1-1V3 C16,2.448,15.552,2,15,2z M14,14H2V5h12V14z" />
            <rect data-color="color-2" x="4" y="7" width="2" height="2" />
            <rect data-color="color-2" x="7" y="7" width="2" height="2" />
            <rect data-color="color-2" x="4" y="10" width="2" height="2" />
            <rect data-color="color-2" x="7" y="10" width="2" height="2" />
            <rect data-color="color-2" x="10" y="7" width="2" height="2" />
            <rect data-color="color-2" x="10" y="10" width="2" height="2" />
          </symbol>
          <symbol id="icon-new" viewBox="0 0 30 18" preserveAspectRatio="none">
            <path fill="#6C953C" d="M0 .1V18h.5L15 14.1 29.5 18h.5V.1z" />
          </symbol>
          <symbol id="icon-select" viewBox="0 0 32 32">
            <path d="M22.759,10.35l-6-7c-0.38-0.443-1.139-0.443-1.519,0l-6,7c-0.254,0.296-0.312,0.714-0.149,1.068 C9.255,11.772,9.609,12,10,12h12c0.391,0,0.745-0.228,0.909-0.582C23.072,11.063,23.013,10.646,22.759,10.35z" />
            <path
              data-color="color-2"
              d="M22,20H10c-0.391,0-0.745,0.228-0.909,0.582c-0.163,0.354-0.104,0.772,0.149,1.068l6,7 C15.431,28.872,15.708,29,16,29s0.569-0.128,0.759-0.35l6-7c0.254-0.296,0.312-0.714,0.149-1.068C22.745,20.228,22.391,20,22,20z"
            />
          </symbol>
        </defs>
      </svg>
    </span>
  )
}
